export function onEnterPress(fn) {
  return keyPressEvent => {
    if (keyPressEvent.key === "Enter") {
      fn();
    }
  };
}
